/* eslint-disable camelcase */
import isMSLegacy from "common/utils/is-ms-legacy";
import { deleteIDBValue, getIDBValue } from "common/utils/storage/idb";
import {
  CURRENT_BUDGET,
  DUE_DATES_STORE,
} from "features/budget/budget.constants";
import {
  clearBudgetRelatedValues,
  getBudgetRelatedValues,
  getStepData,
  LEGACY_clearBudgetRelatedValues,
  LEGACY_getBudgetRelatedValues,
  LEGACY_getStepData,
  LEGACY_saveBudgetRelatedValue,
  LEGACY_saveStepData,
  saveBudgetRelatedValue,
  saveStepData,
} from "features/budget/wizard/state/wizard.storage";
import {
  getRelatedStorageItem,
  removeRelatedStorageItem,
} from "common/utils/storage/legacy-storage";
import { getLocalStorageItem } from "common/utils/storage/local-storage";

const STEP = 3;

export async function saveScheduleAssignments(assignments) {
  if (isMSLegacy() === true) {
    LEGACY_saveStepData(STEP, assignments);
  } else {
    await saveStepData(STEP, assignments);
  }
}

export async function getScheduleAssignments() {
  let scheduleAssignments;

  if (isMSLegacy() === true) {
    scheduleAssignments = LEGACY_getStepData(STEP);
  } else {
    scheduleAssignments = await getStepData(STEP);
  }

  return scheduleAssignments;
}

export async function clearSchedulesAssignments() {
  await saveScheduleAssignments(undefined);
}

export async function removeDueDate(id) {
  if (isMSLegacy() === true) {
    const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
    removeRelatedStorageItem(currentBudgetId, DUE_DATES_STORE, id);
  } else {
    await deleteIDBValue(DUE_DATES_STORE, id);
  }
}

export async function saveDueDate(id, data) {
  if (isMSLegacy() === true) {
    LEGACY_saveBudgetRelatedValue(DUE_DATES_STORE, id, data);
  } else {
    await saveBudgetRelatedValue(DUE_DATES_STORE, id, data);
  }
}

export async function getDueDate(id) {
  let result;

  if (isMSLegacy() === true) {
    const currentBudgetId = getLocalStorageItem(CURRENT_BUDGET);
    result = getRelatedStorageItem(currentBudgetId, DUE_DATES_STORE, id);
  } else {
    result = await getIDBValue(DUE_DATES_STORE, id);
  }
  return result;
}

export async function getDueDates() {
  let result;

  if (isMSLegacy() === true) {
    result = LEGACY_getBudgetRelatedValues(DUE_DATES_STORE);
  } else {
    result = await getBudgetRelatedValues(DUE_DATES_STORE);
  }
  return result;
}

export async function clearDueDates() {
  if (isMSLegacy() === true) {
    LEGACY_clearBudgetRelatedValues(DUE_DATES_STORE);
  } else {
    await clearBudgetRelatedValues(DUE_DATES_STORE);
  }
}
